const clickBtn = document.getElementById("clickBtn");
const popup = document.getElementById("popup");
const closeBtn = document.getElementById("closeBtn");

if (clickBtn && popup && closeBtn) {
    clickBtn.addEventListener('click', () => {
        popup.style.display = 'block';
    });
    closeBtn.addEventListener('click', () => {
        popup.style.display = 'none';
    });
    popup.addEventListener('click', () => {
        popup.style.display = 'none';
    });
}